const botApi = '/BotServices/bot/';

export default class BotManager {
    constructor(config) {
        console.log("BotManager","Bot Manager Instance Created");
        this.config = config;
        this.botSessions = {};
        this.clientBots = {};

        this.botHeartBeatInterval = null;
        //this.botHeartBeat();
    }
    
    initBot(params, callback) {
        console.log("initBot", params);
        let componentId = params.AppId || params.ComponentId;
        if(params.ClientId && componentId) {
            let Client = window.botStore.getClientByID(params.ClientId);
            if(Client) {
                params.MeetingContext = JSON.parse(Client.MeetingContext);
                params.CurrentContext = JSON.parse(Client.CurrentContext);

                if(params.MeetingContext && params.MeetingContext.serverConfig && params.MeetingContext.serverConfig.ServerODN) {
                    let url = "https://" + params.MeetingContext.serverConfig.ServerODN  + "laxroute53.com" + botApi; 
                
                    let request = {
                        method : 'POST',
                        type : "application/json",
                        url : botApi + 'initBotSession',
                        data : params
                    };

                    window.BotServices.httpRequest(request, (err, res) => {
                        console.log("initBotSession Server Resp : ", res);
                        let sessionKey = this.getSessionKey(componentId, params.MeetingContext.MeetingParentId);
                        this.botSessions[sessionKey] = componentId;
                        callback(err, res);
                    });
                } else {
                    callback("Invalid Server Config", null);
                }
            } else {
                callback("Invalid Client ID", null);
            }

        } else {
            callback("Invalid Request", null);
        }
    }

    reloadBot(params, callback) {
        console.log("initBot", params);
        if(params.ClientId && (params.AppId || params.ComponentId)) {
            let Client = window.botStore.getClientByID(params.ClientId);
            params.MeetingContext = JSON.parse(Client.MeetingContext);
            params.CurrentContext = JSON.parse(Client.CurrentContext);

            if(params.MeetingContext && params.MeetingContext.serverConfig && params.MeetingContext.serverConfig.ServerODN) {
                let url = "https://" + params.MeetingContext.serverConfig.ServerODN  + "laxroute53.com" + botApi;   
                console.log("Reload Bot Session : ", url);
                let request = {
                    method : 'POST',
                    type : "application/json",
                    url : url + 'reloadBotSession',
                    data : params
                };

                window.BotServices.httpRequest(request, (err, res) => {
                    console.log("reloadBotSession Server Resp : ", res);
                });
                callback(null, "Bot Manager Initiated");
            } else {
                callback("Invalid Server Config", null);
            }
        } else {
            callback("Invalid Request", null);
        }
    }

    botSend(params, callback) {
        let Client = window.botStore.getClientByID(params.ClientId);
        if(Client) {
            params.MeetingContext = JSON.parse(Client.MeetingContext);
            let sessionKey = this.getSessionKey(componentId, params.MeetingContext.MeetingParentId);
            if(params.ClientId && params.Data && this.botSessions[sessionKey]) {
                if(params.MeetingContext && params.MeetingContext.serverConfig && params.MeetingContext.serverConfig.ServerODN) {
                    let url = "https://" + params.MeetingContext.serverConfig.ServerODN  + "laxroute53.com" + botApi; 
                    params.ComponentId = this.botSessions[sessionKey];
                    params.Type = "Command";
                    let request = {
                        method : 'POST',
                        type : "application/json",
                        url : botApi + 'botSend',
                        data : params
                    };

                    window.BotServices.httpRequest(request, (err, res) => {
                        console.log("botSend Server Resp : ", res);
                    });
                }
            } else {
                callback("Bot Session Expired....!", null);
            }
        } else {
            callback("Invalid Client ID", null);
        }
    }

    initSessionsBot(params, callback) {
        let Client = params;
        console.log("initSessionsBot", Client);
        let currentContext = JSON.parse(Client.CurrentContext);
        if(Client) {
            if(currentContext) {
                // let schema = (currentContext.atComponent && currentContext.atComponent.Schema) ? currentContext.atComponent.Schema : null;
                // let startJson = (currentContext.atComponent && currentContext.atComponent.InitialContext && currentContext.atComponent.InitialContext.startJson) ? currentContext.atComponent.InitialContext.startJson : null;
                // if(startJson || schema && schema.Methods &&  schema.Methods.length > 0 ) {
                if(currentContext.atComponent) {
                    this.clientBots[Client.Client] = Client;
                    let initParams = {
                        Env : window.botStore.env,
                        ClientId : Client.Client,
                        MeetingContext : JSON.parse(Client.MeetingContext),
                        CurrentContext : currentContext
                    };

                    let request = {
                        method : 'POST',
                        type : "application/json",
                        url : botApi + 'initSessionBot',
                        data : initParams
                    };

                    window.BotServices.httpRequest(request, (err, res) => {
                        console.log("initSessionsBot Server Resp : ", res);
                        // Test Request
                        // this.requestClientBot({ClientId : Client.Client, Module : 'sample', Method : 'addNumber', Args : [1,2]}, (err, res) => {
                        //     console.log("requestClientBot Server Resp : ", res);
                        // });
                    });
                    callback(null, "Bot Client Manager Initiated");
                } else {
                    callback("Invalid Client Context", null);
                }
            } else {
                callback("Invalid Client Context", null);
            }
        } else {
            callback("Invalid Client", null);
        }
    }

    requestSessionsBot(params, callback) {
        let Client = this.clientBots[params.ClientId];
        if(Client) {
            let request = {
                method : 'POST',
                type : "application/json",
                url : botApi + 'requestSessionBot',
                data : params
            };

            window.BotServices.httpRequest(request, (err, res) => {
                console.log("requestClientBot Server Resp : ", res);
                callback(null, res);
            });
        } else {
            callback("Invalid Client ID", null);
        }
    }

    getSessionKey(componentId, meetingId) {
        return componentId + meetingId;
    }

    botHeartBeat() {
        this.botHeartBeatInterval = setInterval(() => {
            for(let clientId in this.clientBots) {
                let request = {
                    method : 'POST',
                    type : "application/json",
                    url : botApi + 'botHeartBeat',
                    data : {ClientId : clientId}
                };

                window.BotServices.httpRequest(request, (err, res) => {
                    console.log("botHeartBeat Server Resp : ", err, res);
                    if(err) {
                        console.log("Bot Session Expired....!");
                        delete this.clientBots[clientId];
                    }
                });
            }            
        }, 1000 * 60 * 5) // 5 Minutes;
    }

    awakenComponent(componentId, callback) {
        console.log("awakenComponent got : ", componentId);
        // let request = {
        //     method : 'POST',
        //     type : "application/json",
        //     url : botApi + 'awakenComponent',
        //     data : {ComponentId : componentId}
        // };

        // window.BotServices.httpRequest(request, (err, res) => {
        //     console.log("awakenComponent Server Resp : ", res);
        //     callback(null, res);
        // });
    }
}
